import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import SexLifeTracker from './pages/SexLifeTracker';
import GrowIQ from './pages/GrowIQ';
import FeelOMeter from './pages/FeelOMeter';
import RewardlyAI from './pages/RewardlyAI';
import RewardlySupport from './pages/RewardlySupport';
import PriceTrackerDealAlerts from './pages/PriceTrackerDealAlerts';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sexlife-tracker" element={<SexLifeTracker />} />
            <Route path="/growiq" element={<GrowIQ />} />
            <Route path="/feel-o-meter-ai-mood-tracker" element={<FeelOMeter />} />
            <Route path="/rewardly-ai-card-rewards" element={<RewardlyAI />} />
            <Route path="/rewardly-ai-card-rewards/support" element={<RewardlySupport />} />
            <Route path="/price-tracker-deal-alerts" element={<PriceTrackerDealAlerts />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
          </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
